import clsx from "clsx";
import { RowSpinner } from "./Loader/Loader";

const SIZES = {
  md: "px-6 py-3 text-sm font-medium rounded-2xl",
  sm: "px-3 py-1.5 text-xs font-medium rounded-lg",
  lg: "h-[44px] px-5 text-sm font-semibold rounded-xl",
  xl: "h-[48px] px-6 text-sm font-semibold rounded-xl",
  // mock `.modal .btn-lg`: the planner dialog actions
  modal: "h-[52px] px-6 text-sm font-semibold rounded-xl flex-[1_1_180px]",
};

function PrimaryButton({ children, size = "md", loading = false, disabled, className, ...rest }) {
  return (
    <button
      type="button"
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={clsx(
        "inline-flex items-center justify-center gap-2 text-white bg-gradient-to-r from-cyan-650 to-cyan-75",
        "hover:brightness-110 active:brightness-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:brightness-100",
        SIZES[size],
        className,
      )}
      {...rest}
    >
      {loading && <RowSpinner className="!w-4 !h-4 !border-white !border-t-transparent" />}
      {children}
    </button>
  );
}

export default PrimaryButton;
